import React from 'react'

const WMW = () => {
  return (
    <section className="project">
      <p>This is Which Movie is Worse game!</p>
      <iframe title="WMW" src="https://which-movie-is-worse.onrender.com/" />
    </ section>
  )
}

export default WMW;